import Rollbar from "rollbar";

const getEnvironment = (): string => {
	return import.meta.env.VITE_ENVIRONMENT || "development";
};

const isProduction = (): boolean => {
	const env = getEnvironment();
	return env === "production";
};

export const rollbarConfig: Rollbar.Configuration = {
	accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN || "",
	environment: getEnvironment(),
	enabled: isProduction(),
	codeVersion: __GIT_COMMIT_HASH__,
	captureUncaught: true,
	captureUnhandledRejections: true,
	payload: {
		client: {
			javascript: {
				code_version: __GIT_COMMIT_HASH__,
				source_map_enabled: true,
			},
		},
	},

	// Ignore specific error types that are not actionable
	checkIgnore: (_isUncaught, _args, payload) => {
		const body = payload.body as
			| { message?: { message?: string }; statusCode?: number }
			| undefined;
		const message = body?.message?.message;

		if (message && typeof message === "string") {
			// Network errors (client connectivity issues)
			if (message.includes("Network Error")) {
				return true;
			}

			// Authentication errors (user-facing, not bugs)
			if (message.includes("Invalid login credentials")) {
				return true;
			}

			// Additional client-side errors that are not actionable
			const ignoredPatterns = [
				"Failed to fetch", // Browser fetch failures
				"Network request failed", // Mobile network issues
				"timeout of", // Request timeouts
				"ECONNABORTED", // Aborted connections
				"Request aborted", // User cancelled requests
				"ERR_NETWORK", // Browser network errors
				"ERR_CONNECTION_REFUSED", // Connection refused
				"Load failed", // Resource load failures
				"AbortError", // Fetch API aborts
			];

			if (ignoredPatterns.some((pattern) => message.includes(pattern))) {
				return true;
			}
		}

		// Ignore 4xx client errors (validation, auth, not found, etc.)
		const statusCode = body?.statusCode;
		if (statusCode && statusCode >= 400 && statusCode < 500) {
			return true;
		}

		return false;
	},
};

// Log configuration status
if (!isProduction()) {
	console.log("[Rollbar] Disabled in", getEnvironment(), "environment");
} else if (!import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN) {
	console.warn(
		"[Rollbar] Access token not configured. Errors will not be reported.",
	);
} else {
	console.log("[Rollbar] Enabled in production environment");
}
